<template lang="html">
  <form @submit.prevent="submit">
    <TextField
      v-model="value"
      name="search"
    >
      <SearchIcon
        slot="after"
        class="search-field__icon"
      />
    </TextField>
    <button type="submit" class="screen-reader-only">
      Search
    </button>
  </form>
</template>

<script>
import TextField from 'beisheim/components/elements/text-field'
import SearchIcon from 'beisheim/assets/images/icons/beisheim-stiftung-search.svg'

export default {
  components: {
    SearchIcon,
    TextField
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.value)
    }
  }
}
</script>

<style lang="scss">
.search-field__icon {
  width: 2rem;
}
</style>
